import store from "@/store";
import { EventBus } from "@/eventbus";

const tourConfig = {
  //https://kamranahmed.info/driver.js/
  className: "tour-style",
  opacity: 0.12,
  padding: 0,
  closeBtnText: " ",
  prevBtnText: "Previous",
  allowClose: false,
  nextBtnText: "Next",
  onReset: () => {
    store.commit("brain/ui/showTour", false);
  },
};

const repositionCta = () => {
  // The CTAs need to be repositioned, otherwise they end up all over the place
  EventBus.$emit("repositionCta");
};

const tourSteps = [
  {
    element: ".module-table",
    popover: {
      className: "pop-over-className",
      title: "Modules <span class='tour-progress'>1/8</span>",
      description:
        "As an exercise, select one of the available modules. Then select 'Add to new solution' in the 3-dots to start your first combination.",
      position: "right-center",
    },
    onNext: repositionCta,
  },
  {
    element: ".driver-table",
    popover: {
      className: "pop-over-className",
      title: "Drivers <span class='tour-progress'>2/8</span>",
      description:
        "As an exercise, select one of the available drivers. Then select 'Add to current solution' in the 3-dots to complete your first solution.",
      position: "left-center",
    },
    onPrevious: repositionCta,
    onNext: repositionCta,
  },
  {
    element: ".splitpanes",
    popover: {
      className: "pop-over-className",
      title: "Product lists <span class='tour-progress'>3/8</span>",
      description:
        "Both product lists show results that meet the filter and calculation criteria.",
      position: "mid-center",
    },
    onPrevious: repositionCta,
    onNext: repositionCta,
  },
  // {
  //   element: ".action-bar",
  //   popover: {
  //     className: "pop-over-className",
  //     title: "View settings <span class='tour-progress'>3/9</span>",
  //     description: "This bar hosts the list view settings.",
  //     position: "bottom-center"
  //   }
  // },
  {
    element: "#module-calculate-performance",
    popover: {
      className: "pop-over-className",
      title: "Calculations <span class='tour-progress'>4/8</span>",
      description:
        "Here the operating values can be entered, and the performance calculated.",
      position: "right-center",
    },
    onPrevious: repositionCta,
    onNext: repositionCta,
  },
  {
    element: "#module-filters",
    popover: {
      className: "pop-over-className",
      title: "Filters <span class='tour-progress'>5/8</span>",
      description:
        "The filters help to narrow down the list results to your needs.",
      position: "right-center",
    },
    onPrevious: repositionCta,
    onNext: repositionCta,
  },
  {
    element: "#module-graph",
    popover: {
      className: "pop-over-className",
      title: "Graph <span class='tour-progress'>6/8</span>",
      description:
        "The graph shows the operating point within the operating range for the selected product.",
      position: "right-center",
    },
    onPrevious: repositionCta,
    onNext: repositionCta,
  },
  // {
  //   element: ".action-bar .toggles",
  //   popover: {
  //     className: "pop-over-className",
  //     title: "Toggles <span class='tour-progress'>7/9</span>",
  //     description: "Toggle product list visibility.",
  //     position: "bottom-center"
  //   }
  // },
  {
    element: ".icons",
    popover: {
      className: "pop-over-className",
      title: "Apps <span class='tour-progress'>7/8</span>",
      description:
        "Access to the menu for your account-related items, related apps and the product search.",
      position: "bottom-right",
    },
    onPrevious: repositionCta,
    onNext: repositionCta,
  },
  {
    element: ".guide-me",
    popover: {
      className: "pop-over-className",
      title: "Help <span class='tour-progress'>8/8</span>",
      description:
        "At any time, you can press Restart to clear all selections and values, or activate the Guide me for guidance. Clicking on the Signify logo will bring you to the Landing page.",
      position: "bottom-left",
    },
    onPrevious: repositionCta,
  },
];

export { tourSteps, tourConfig };
